module.exports = __webpack_public_path__ + "media/books/BooksFocus3-dba52880.jpg";